var _g, _g2, _rect, _g3, _use, _use2, _rect2, _g4, _use3, _use4, _use5, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path, _use6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUruguay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    viewBox: "0 0 57 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c6a511"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.068796
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.021188
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.095 0 0 .095 -128.15 -1.6921)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 38,
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m0 35h57",
    fill: "none",
    stroke: "#5095c5",
    strokeDashoffset: 6.3,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(0,-4)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "translate(0,-8)",
    xlinkHref: "#g"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0,-16)",
    xlinkHref: "#f"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0,-32)",
    xlinkHref: "#b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m9 9.0001 1.4257 0.59053 1.8223-8.4317-4.6736 7.2507 1.4257 0.59053 3.2479-7.8412",
    fill: "#c6a511",
    stroke: "#7b3f00",
    strokeMiterlimit: 20,
    strokeWidth: 0.15431
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(90 9 9.0001)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(180,9,9)",
    xlinkHref: "#e"
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(45,9,9)",
    xlinkHref: "#a"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.35108 .84758 -.84758 .35108 13.468 -1.7879)",
    xlinkHref: "#a"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.99325 .41142 -.41142 .99325 3.7635 -3.642)",
    xlinkHref: "#a"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#c6a511"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.030576
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.009417
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.042222 0 0 .042222 -48.731 -88.297)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#c6a511"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.030576
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.009417
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.042222 0 0 .042222 -42.564 -37.963)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 2.917,
    fill: "#f2c916",
    stroke: "#7b3f00",
    strokeMiterlimit: 20,
    strokeWidth: 0.15906
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#7b3f00",
    strokeWidth: 0.24806
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5957 9.1698c-0.22742 0.05054-0.15165 0.37904-0.3538 0.40431-0.20215 0.02527-0.30318 0.25267-0.27791 0.22741 0.12634-0.10107 0.40431-0.1769 0.60646-0.1769 0.20215 0 0.25268 0.12639 0.42956 0.12639 0.17688 0 0.22741-0.12639 0.42956-0.12639 0.20215 0 0.48012 0.07582 0.60646 0.1769 0.02527 0.02527-0.075765-0.20214-0.27791-0.22741-0.20215-0.02527-0.12638-0.35377-0.3538-0.40431 0 0.10107 0.075744 0.0758 0.10101 0.22741 0 0.12634-0.22738 0.12634-0.27791 0 0.050537 0.20215-0.10106 0.20215-0.22741 0.20215-0.12634 0-0.27794-5e-6 -0.22741-0.20215-0.050537 0.12634-0.27791 0.12634-0.27791 0 0.025268-0.15161 0.10101-0.12634 0.10101-0.22741z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.8123 10.029c-0.20215 0.15161-0.25265 0.22743-0.27791 0.40431 0.060607-0.10606 0.090371-0.14965 0.13639-0.21202-0.01218-0.0052-0.022651-0.01005-0.035252-0.01538 0.01471 0.0017 0.027886 4e-3 0.042046 6e-3 0.03056-0.04128 0.057711-0.07703 0.13473-0.18292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.6776 10.212c-7.178e-4 9.92e-4 -0.0025 0.0034-0.0032 0.0044 0.03159 0.0073 0.065101 0.01077 0.10024 0.01089-0.030869-0.0055-0.063315-0.01054-0.097039-0.01526z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.7746 10.227c0.15758 0.02782 0.28129 0.06407 0.39469 0.10075 0.14143-0.01047 0.33652-0.04627 0.83066-0.04627 0.49414 0 0.68923 0.03581 0.83066 0.04627 0.1134-0.03668 0.23712-0.07294 0.39469-0.10075-0.27844 9.92e-4 -0.64957-0.19818-0.82105-0.19818-0.20215 0-0.2527 0.05051-0.40431 0.05051-0.15161 0-0.20216-0.05051-0.40431-0.05051-0.17148 0-0.54261 0.19919-0.82105 0.19818z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.225 10.227c0.03514-1.27e-4 0.06865-0.0035 0.10024-0.01089-7.18e-4 -9.93e-4 -0.0025-0.0034-0.0032-0.0044-0.03373 0.0047-0.06617 0.0098-0.09704 0.01526z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.322 10.212c0.01416-2e-3 0.02734-0.0042 0.04205-6e-3 -0.0126 0.0053-0.02307 0.01015-0.03525 0.01538 0.04602 0.06237 0.07579 0.10596 0.13639 0.21202-0.02527-0.17688-0.07577-0.25269-0.27791-0.40431 0.07702 0.1059 0.10417 0.14165 0.13473 0.18292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.329 10.221c-2.96e-4 -4.99e-4 -9.93e-4 -0.0015-0.0013-0.0017-0.26372 0.1016-0.35656 0.11886-0.49724 0.10845-0.23958 0.0775-0.43707 0.15588-0.83066 0.15588-0.39359 0-0.59108-0.07838-0.83066-0.15588-0.14068 0.01042-0.23353-0.0068-0.49724-0.10845-2.956e-4 4.98e-4 -9.922e-4 0.0015-0.00129 0.0017 0.7938 0.34166 0.70702 0.46468 1.3292 0.46468s0.53538-0.12302 1.3292-0.46468z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.6721 10.219c4.983e-4 -7.43e-4 0.00179-0.0025 0.00231-0.0032-0.013172-3e-3 -0.026431-0.0059-0.038841-0.01039 0.014425 0.0057 0.023074 0.0084 0.036534 0.01359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.328 10.219c0.01346-0.0052 0.02211-0.0079 0.03653-0.01359-0.01241 0.0045-0.02567 0.0073-0.03884 0.01037 4.98e-4 7.43e-4 0.0018 0.0025 0.0023 0.0032z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.5849 8.0833c-0.12634 0.05054-0.32849 0.30319 0 0.48007-0.25269-0.17688-0.050537-0.42953 0-0.48007z",
    fill: "#7b3f00",
    strokeWidth: 0.24806
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.9532 7.8811c0.17688 0.20215 0.27795-0.15161 0.90967-0.15161s0.73279 0.37903 0.83386 0.30322c0.10107-0.07581-0.53064-0.53064-0.73279-0.55591-0.20215-0.02527-0.78332 0.17688-1.0107 0.4043m0.73279 0.22742c-0.17688 0.15161-0.025269 0.4801 0.15161 0.4801 0.17688 0 0.50537-0.30322 0.35376-0.50537",
    fill: "#7b3f00",
    strokeWidth: 0.025268
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5199 8.3359c-0.025269-0.30322-0.27795-0.35376-0.68225-0.35376-0.4043 0-0.58118 0.30322-0.73279 0.37903 0.17688 0 0.32849-0.25269 0.73279-0.25269 0.4043 0 0.4043 0 0.68225 0.25269m-0.075806 0.05054c-0.10107-0.15161-0.22742 0.15161-0.50537 0.15161-0.27795 0-0.42957-0.07581-0.60644-0.20215-0.17688-0.12634 0.25269 0.30322 0.53064 0.30322s0.65698-0.15161 0.58118-0.25268",
    fill: "#7b3f00",
    strokeWidth: 0.025268
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 10.913c-0.12634 0-0.45483 0.0758 0 0.0758 0.45483 0 0.12634-0.0758 0-0.0758",
    fill: "#7b3f00",
    strokeWidth: 0.24806
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1,0,0,1,18,0)",
    xlinkHref: "#d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUruguay);
export default __webpack_public_path__ + "static/media/uruguay.8dbe04ac929c1701c2d6e7e9d3342d43.svg";
export { ForwardRef as ReactComponent };